export const GlobeIcon = (props) => (
  <svg
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3337 10.0013C18.3337 14.6037 14.6027 18.3346 10.0003 18.3346M18.3337 10.0013C18.3337 5.39893 14.6027 1.66797 10.0003 1.66797M18.3337 10.0013H1.66699M10.0003 18.3346C5.39795 18.3346 1.66699 14.6037 1.66699 10.0013M10.0003 18.3346C12.0847 16.0527 13.2693 13.0913 13.3337 10.0013C13.2693 6.91133 12.0847 3.94993 10.0003 1.66797M10.0003 18.3346C7.91593 16.0527 6.73137 13.0913 6.66699 10.0013C6.73137 6.91133 7.91593 3.94993 10.0003 1.66797M1.66699 10.0013C1.66699 5.39893 5.39795 1.66797 10.0003 1.66797"
      stroke={props?.color || '#667085'}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
